// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

type ErrorTextType = {
  header: string;
  message: string | JSX.Element;
};

const ErrorText = ({ header, message }: ErrorTextType) => {
  return (
    <Box
      height="400px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      gap="20px"
    >
      <Typography fontSize="16px" fontWeight="bold" maxWidth="400px">
        {header}
      </Typography>
      {typeof message === "string" ? (
        <Typography maxWidth="400px">{message}</Typography>
      ) : (
        message
      )}
    </Box>
  );
};

export default ErrorText;
